(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.link_highlights = {
    attach: function (context, settings) {
      $('.field--name-field-link-highlights', context).each(function() {
        var $container = $(this);
        var itemCount = $container.children('.field__item').length;
        var countClass = 'item-count-' + Math.min(itemCount, 4);
        $container.addClass(countClass);
      });
    }
  };

})(jQuery, Drupal);
